import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const AxleType = ({ axleType }: SpecProps<"axle_type">) => {
  const { i18n } = useLingui();

  if (!axleType) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.truck.axleType",
    message: "Axle type",
    comment: "Field for 'Axle type' for truck and bus in ad specification",
  });

  return <FieldValuePair field={field} value={axleType.value} />;
};
